<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 18 18">
  <path
    d="M12.7 6.7l-1.4-1.4 1.9-1.9C12 2.5 10.6 2 9 2c-3.9 0-7 3.1-7 7 0 1.6 0.5 3 1.4 4.2l1.9-1.9 1.4 1.4L4.8 14.6C6 15.4 7.4 16 9 16c3.9 0 7-3.1 7-7 0-1.6-0.5-3-1.4-4.2L12.7 6.7zM9 11.6c-1.4 0-2.6-1.2-2.6-2.6S7.6 6.3 9 6.3s2.6 1.2 2.6 2.6S10.4 11.6 9 11.6z"
    fill="#231F20" />
  <circle cx="9" cy="9" r="1.4" fill="#231F20" />
</svg>
